
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PlanReplacementModel } from './Entities.GormCrm.PlanReplacement';
import { ProductPlanModel } from './Entities.GormCrm.ProductPlan';
import { Model, ModelProperty } from 'models/Model';


export class PlanReplacementNewPlanModel extends Model<PlanReplacementNewPlanModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'planReplacementNewPlan.property.id', isHidden: true },
		{ name: 'planReplacementId', type: 'guid', languageString: 'planReplacementNewPlan.property.planReplacementId' },
		{ name: 'productPlanId', type: 'guid', languageString: 'planReplacementNewPlan.property.productPlanId' },
		{ name: 'equalizingAmount', type: 'number', languageString: 'planReplacementNewPlan.property.equalizingAmount' },
		{ name: 'equalizingRemainingValue', type: 'number', languageString: 'planReplacementNewPlan.property.equalizingRemainingValue' },
		{ name: 'equalizingPercentage', type: 'number', languageString: 'planReplacementNewPlan.property.equalizingPercentage' },
		{ name: 'planReplacement', type: 'PlanReplacementModel', languageString: 'planReplacementNewPlan.property.planReplacement', isHidden: true, isObject: true, new: () => { return new PlanReplacementModel }, properties: () => { return PlanReplacementModel.classProperties } },
		{ name: 'productPlan', type: 'ProductPlanModel', languageString: 'planReplacementNewPlan.property.productPlan', isHidden: true, isObject: true, new: () => { return new ProductPlanModel }, properties: () => { return ProductPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public planReplacementId?: string;
	public productPlanId?: string;
	public equalizingAmount: number;
	public equalizingRemainingValue: number;
	public equalizingPercentage: number;
	public planReplacement?: PlanReplacementModel;
	public productPlan?: ProductPlanModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.planReplacementId = undefined;
		this.productPlanId = undefined;
		this.equalizingAmount = 0;
		this.equalizingRemainingValue = 0;
		this.equalizingPercentage = 0;
		this.planReplacement = undefined;
		this.productPlan = undefined;
		
	}
	getProperties(){
		return PlanReplacementNewPlanModel.classProperties;
	}
}

